/* ═══════════════════════════════════════════════════════════════
 * CONFIG — centrale instellingen + kleuren (canvas-kant)
 * 1:1 poort van TERMINAL.CONFIG uit terminal_wyckoffpcg.html.
 * ═══════════════════════════════════════════════════════════════ */

export const CONFIG = {
  // ── Data ──────────────────────────────────────────────────────
  defaultSymbol: "BTCUSDT",
  defaultInterval: "15m",

  // Instrumenten in de symbool-dropdown. `source` bepaalt welke databron
  // CoachTerminal.jsx gebruikt: "binance" (default, REST+WS zoals altijd)
  // of "yahoo" (REST-only via onze Worker-proxy + polling, zie spx.js —
  // geen live WebSocket-feed beschikbaar voor gratis index-data).
  symbols: [
    { sym: "BTCUSDT", label: "BTC" },
    { sym: "ETHUSDT", label: "ETH" },
    { sym: "SOLUSDT", label: "SOL" },
    { sym: "BNBUSDT", label: "BNB" },
    { sym: "XRPUSDT", label: "XRP" },
    { sym: "DOGEUSDT", label: "DOGE" },
    { sym: "PAXGUSDT", label: "GOLD" }, // PAX Gold — 1:1 fysiek goud, volgt de goudprijs
    { sym: "^GSPC", label: "SPX", source: "yahoo" }, // S&P 500-index, via Yahoo Finance (zie spx.js)
  ],

  // Timeframes (Binance kline-intervallen). Label = wat de knop toont.
  intervals: [
    { v: "1m", label: "1m" }, { v: "3m", label: "3m" }, { v: "5m", label: "5m" },
    { v: "15m", label: "15m" }, { v: "30m", label: "30m" }, { v: "1h", label: "1h" },
    { v: "2h", label: "2h" }, { v: "4h", label: "4h" }, { v: "6h", label: "6h" },
    { v: "12h", label: "12h" }, { v: "1d", label: "1D" }, { v: "3d", label: "3D" },
    { v: "1w", label: "1W" }, { v: "1M", label: "1M" },
  ],

  klineLimit: 3000, // aantal historische candles bij laden (gepagineerd: 3x 1000 requests)

  // ── ATR Grid (locked config, uit atr_grid.py) ──────────────────
  atrGrid: {
    symbol: "BTCUSDT",
    anchor: 15512.0,
    atr: 2223.0,
    quarter: 0.25,
    band: 4,
    period: 14,
    swingWindow: 15,
    showQuarters: true,
    labelHalf: false,
    confTol: 0,
    showStructural: false, // zet aan om de structurele niveaus (RANGE/TP/BREAK-TEST) weer te highlighten
    colFull: "#8b9bb0",
    colHalf: "#5a6675",
    colQuarter: "#39424e",
    colConf: "#f0b90b",
    structural: {
      "RANGE LOW": 75512.0,
      "TP 77.748": 77748.0,
      "TP 78.014": 78014.0,
      "BREAK/TEST": 80019.0,
      "TP 80.642": 80642.0,
      "RANGE HIGH": 81612.0,
    },
  },

  // ── Wyckoffee PCG Indicator (poort van de Pine-script versie) ──
  wyckoffPcg: {
    tf: "1h",
    zigzagPct: 2.4,
    minZigzag: 2,
    bMinBars: 5,
    bMinPct: 0,
    mode: "both",
    klineLimit: 1000,
    pollMs: 20000,
    trendBars: 50,
    trendPct: 0.3,
    maxSwingsAfterB3: 6,
    maxSwingsAfterC: 8,
    colors: {
      scAr: "#2962ff",
      ar: "#00897b",
      st: "#1a237e",
      mid: "#f0b90b",
      b: "#f5a623",
      b3: "#e0455b",
      c1: "#e040fb",
      c2: "#9c27b0",
      dsowLps: "#26a17b",
      dsosSos: "#c6ff00",
    },
  },

  maxTrades: 60,
  maxCvdPoints: 500,

  // ── Volume Profile ────────────────────────────────────────────
  vpBuckets: 120,
  vpValueArea: 0.70,
  vpWidthFrac: 0.34,
  vpShowBars: false,

  // ── Order Book Heatmap (Bookmap-stijl) ────────────────────────
  depthLimit: 500,
  depthPollMs: 1000,
  heatWidth: 58,
  heatWalls: 3,

  // ── Kleuren (dubforvet-tokens) ──────────────────────────────────
  colors: {
    up: "#26a17b",
    upLive: "#26de81",
    down: "#e0455b",
    accent: "#f0b90b",
    accentSoft: "rgba(240,185,11,0.14)",
    text: "#e6e8ea",
    dim: "#8b95a1",
    faint: "#6b7480",
    grid: "#12171d",
    borderHair: "#1c2127",

    vpFill: "rgba(120,150,180,0.22)",
    vpFillVA: "rgba(120,160,200,0.40)",
    poc: "#f0b90b",
    vaLine: "rgba(240,185,11,0.55)",

    buy: "#26de81",
    sell: "#e0455b",
    pdh: "#26a17b",
    pdl: "#e0455b",
    dayOpen: "#3aa0c8",

    obBid: "56,161,123",
    obAsk: "224,69,91",
  },

  // ── Binance endpoints ────────────────────────────────────────────
  binance: {
    rest: "https://api.binance.com/api/v3/klines",
    wsBase: "wss://stream.binance.com:9443/stream?streams=",
  },
};
